import React, { useState } from "react";
import Slider from "react-slick";
import propfyi from "../../src/image/project/propfyi.png";
import kanpid from "../../src/image/project/kanpid.png";
import sokudo from "../../src/image/project/sokudo.png";
import wigomania from "../../src/image/project/wigomania.png";
import dynamisers from "../../src/image/project/dynamisers.png";
import arrow from "../../src/image/project/arrow.png";
import carstreet from "../../src/image/project/carstreet.png";
import lebiz from "../../src/image/project/lebiz.png";
import cartfo from "../../src/image/project/cartfo.png";
import bimahelpdex from "../../src/image/project/bimahelpdex.png";
import iaapp from "../../src/image/project/iaapp.png";
import xenia from "../../src/image/project/xenia.png";
import brightdealers from "../../src/image/project/brightdealers.png";
import aquatopper from "../../src/image/project/aquatopper.png";
import burgerlane from "../../src/image/project/burgerlane.png";
import caravan from "../../src/image/project/caravan.png";
import sql from "../../src/image/project/sql.png";
import growing from "../../src/image/project/growing.png";
import brows from "../../src/image/project/brows.png";
import gems from "../../src/image/project/gems.png";
import film from "../../src/image/project/film.png";
import ambition from "../../src/image/project/ambition.png";
import haram from "../../src/image/project/haram.png";
import beautyclinic from "../../src/image/project/beautyclinik.png";
import pcli from "../../src/image/project/pcli.png";
import altman from "../../src/image/project/altman.png";
import mediaatech from "../../src/image/project/mediatech.png";
import griller from "../../src/image/project/griller.png";
import interior from "../../src/image/project/interior.png";
import tilikum from "../../src/image/project/tilikum.png";
import venessa from "../../src/image/project/vanessa.png";
import { FaLink } from "react-icons/fa";

const MyWorks = () => {
  const webData = [
    {
      project_name: "Propfyi",
      discription: "Real State Project || React Js || Node Js ",
      link: "http://propfyi.com/",
      image: propfyi,
    },
    {
      project_name: "Caravan Parking",
      discription: "Parking Website || SVG || Javascipt",
      link: "https://figtreecaravanstorage.com.au/",
      image: caravan,
    },
    {
      project_name: "Cartfo",
      discription: "E-Commerce Project || React Js",
      link: "https://cartfo.netlify.app/",
      image: cartfo,
    },
    {
      project_name: "Sokudo India",
      discription: "E-Scooter Project || Frontend || Php",
      link: "https://www.sokudoindia.com/",
      image: sokudo,
    },
    {
      project_name: "Arrow Pc Network",
      discription: "It Service Project  || Frontend || Php",
      link: "https://arrowpcnetwork.com/",
      image: arrow,
    },
    {
      project_name: "Kanpid",
      discription: "E-Commerce Project  || Frontend || Laravel",
      link: "https://kanpid.com/",
      image: kanpid,
    },
    {
      project_name: "Dynamisers Solution",
      discription: "Company Project  || Frontend || Php",
      link: "https://dynamisers.com/",
      image: dynamisers,
    },
    {
      project_name: "Wigomania Studio",
      discription: "Saloon Project  || Frontend || Laravel",
      link: "https://wigomaniahairstudio.com/",
      image: wigomania,
    },
    {
      project_name: "Carstreet India",
      discription: "Luxury Cars Dealers Project  || Frontend || Php",
      link: "https://www.carstreetindia.com/",
      image: carstreet,
    },
    {
      project_name: "Lebiz Canada",
      discription: "Immegrartion Project  || Frontend || Php",
      link: "https://lebizcanada.com/",
      image: lebiz,
    },
  ];
  const appData = [
    {
      project_name: "Bimahelpdex",
      discription: "Insurance App || React Native",
      link: "https://play.google.com/store/apps/details?id=com.beemahelp&pcampaignid=web_share",
      image: bimahelpdex,
    },
    {
      project_name: "Aquatopper",
      discription: "Automatic Swimming Pool || React Native",
      link: "https://play.google.com/store/apps/details?id=com.aquatopper.app&pcampaignid=web_share",
      image: aquatopper,
    },
    {
      project_name: "Kanpid",
      discription: "E-Commerce App || React Native",
      link: "https://play.google.com/store/apps/details?id=com.kanpid.nivethika&pcampaignid=web_share",
      image: kanpid,
    },
    {
      project_name: "Propfyi",
      discription: "Real State App || React Native",
      link: "https://apps.apple.com/us/app/propfyi/id6475808475",
      image: propfyi,
    },
    {
      project_name: "Xeniacot",
      discription: "Dating App || React Native",
      link: "#",
      image: xenia,
    },
    {
      project_name: "Iaapp",
      discription: "Document Management App || React Native",
      link: "https://play.google.com/store/apps/details?id=com.iaapp&pcampaignid=web_share",
      image: iaapp,
    },
    {
      project_name: "Bright Dealer",
      discription: "E-Commerce App || React Native",
      link: "https://play.google.com/store/apps/details?id=com.brightdealers&pcampaignid=web_share",
      image: brightdealers,
    },
    {
      project_name: "Burger Lane",
      discription: "Food App || React Native",
      link: "#",
      image: burgerlane,
    },
  ];
  const wordpressData = [
    {
      project_name: "SQL-Pulchram",
      discription: "Real State || Wordpress",
      link: "https://dev.codesmile.in/sqltest/",
      image: sql,
    },
    {
      project_name: "Growing Miracles",
      discription: "Childcare and Learning || Wordpress",
      link: "https://growingmiracleschildcare.com/",
      image: growing,
    },
    {
      project_name: "Brows By Namee",
      discription: "Saloon || Wordpress",
      link: "https://browsbynamee.co.uk/",
      image: brows,
    },
    {
      project_name: "Gems & Jwelles",
      discription: "Jwellery || Wordpress",
      link: "https://www.gemsinjewels.com/",
      image: gems,
    },
    {
      project_name: "Brihaspati Films",
      discription: "Film Studio || Wordpress",
      link: "https://brihaspatifilms.com/",
      image: film,
    },
    {
      project_name: "Ambition Radio",
      discription: "Radio Studio || Wordpress",
      link: "https://ambitionradio.com/",
      image: ambition,
    },
    {
      project_name: "Haram Transfer",
      discription: "Company Website || Wordpress",
      link: "https://haram-transfer.com/",
      image: haram,
    },
    {
      project_name: "Beauty Clinic",
      discription: "Saloon || Wordpress",
      link: "https://beauty-clinic.co.il/",
      image: beautyclinic,
    },
    {
      project_name: "Pest Exterminators",
      discription: "Exterminators || Wordpress",
      link: "https://pc-il.org/",
      image: pcli,
    },
    {
      project_name: "Altman",
      discription: "E-Commerce || Wordpress",
      link: "https://www.altman.co.il/lp/",
      image: altman,
    },
    {
      project_name: "Mediatech",
      discription: "Company Website || Wordpress",
      link: "https://www.mediaatech.com/",
      image: mediaatech,
    },
    {
      project_name: "The Griller",
      discription: "Safety Matches || Wordpress",
      link: "https://dev.codesmile.in/TheGriller/",
      image: griller,
    },
    {
      project_name: "Shir Meidan",
      discription: "Interior || Wordpress",
      link: "https://dev.codesmile.in/interior/",
      image: interior,
    },
    {
      project_name: "Tilikum Wealth Management",
      discription: "Wealth Management || Wordpress",
      link: "https://www.tilikumwealth.co.uk/",
      image: tilikum,
    },
    {
      project_name: "Portfolio",
      discription: "Portfolio || Wordpress",
      link: "https://vanessagardinersupervision.co.uk/",
      image: venessa,
    },
  ];

  const [app, setApp] = useState(true);
  const [web, setWeb] = useState(true);
  const [wordpress, setWordpress] = useState(true);

  return (
    <>
      <section className="experience_section" id="work">
        <div className="container">
          <h2 className="about_main_heading">Projects</h2>

          <div className="row">
            <div className="col-lg-12">
              <div className="work_main_div">
                <a
                  className="work_btn"
                  onClick={() => {
                    setApp(true);
                    setWeb(true);
                    setWordpress(true);
                  }}
                >
                  All
                </a>
                <a
                  className="work_btn"
                  onClick={() => {
                    setWeb(true);
                    setApp(false);
                    setWordpress(false);
                  }}
                >
                  Web
                </a>
                <a
                  className="work_btn"
                  onClick={() => {
                    setApp(true);
                    setWeb(false);
                    setWordpress(false);
                  }}
                >
                  App
                </a>
                <a
                  className="work_btn"
                  onClick={() => {
                    setApp(false);
                    setWeb(false);
                    setWordpress(true);
                  }}
                >
                  Wordpress
                </a>
              </div>
            </div>
          </div>

          {web && (
            <div className="row mt-3">
              {webData?.map((item, index) => {
                return (
                  <div className="col-lg-4 mt-3">
                    <div className="project_div">
                      <div>
                        <img src={item.image} className="project-image" />
                      </div>
                      <div className="img_absolute">
                        <FaLink
                          className="link_icon"
                          onClick={() => {
                            window.open(item.link);
                          }}
                        />
                      </div>

                      <h2>{item.project_name}</h2>
                      <p>{item.discription}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {app && (
            <div className="row mt-3">
              {appData?.map((item, index) => {
                return (
                  <div className="col-lg-4 mt-3">
                    <div className="project_div">
                      <div>
                        <img src={item.image} className="project-image" />
                      </div>
                      <div className="img_absolute">
                        <FaLink
                          className="link_icon"
                          onClick={() => {
                            if (item.link === "#") {
                            } else {
                              window.open(item.link);
                            }
                          }}
                        />
                      </div>
                      <h2>{item.project_name}</h2>
                      <p>{item.discription}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {wordpress && (
            <div className="row mt-3">
              {wordpressData?.map((item, index) => {
                return (
                  <div className="col-lg-4 mt-3">
                    <div className="project_div">
                      <div>
                        <img src={item.image} className="project-image" />
                      </div>
                      <div className="img_absolute">
                        <FaLink
                          className="link_icon"
                          onClick={() => {
                            if (item.link === "#") {
                            } else {
                              window.open(item.link);
                            }
                          }}
                        />
                      </div>
                      <h2>{item.project_name}</h2>
                      <p>{item.discription}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default MyWorks;
